import { LeadDTOItem, LeadPostDTO, LeadSourceDTO } from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

export type PublicLeadApiType = ReturnType<typeof publicLeadApi>;

const publicLeadApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    create(newResource: LeadPostDTO) {
      return axiosInstance.post<LeadDTOItem>(
        `${clubPrefix}hosted/lead`,
        newResource,
      );
    },
    findLeadSources() {
      return axiosInstance.get<LeadSourceDTO[]>(
        `${clubPrefix}hosted/lead/source`,
      );
    },
  };
};

export default publicLeadApi;
